
// Registers a matomo event
export const registerMatomoEvent = (eventCategory: string, eventAction: string, eventName: string): Breakpoint => {
    if (window._paq) {
        window._paq.push(['trackEvent', eventCategory, eventAction, eventName]);
    }
};